import { ApiError, fetchWithAuth } from "@entities/user-tokens";

/**
 * スライドフォーマットを削除する。
 *
 * アドインで要るのは、**生成開始に失敗したときの後片付け**である。独立実行は現在の pptx を
 * 使い捨てフォーマット（`origin=task`）として先に登録するので、そのあとタスクの作成が失敗すると
 * 誰からも見えない写しが残る（記録 48）。一時フォーマットは一覧に出ないため、残ると画面からは
 * 消せない。
 */
export async function deleteSlideFormat(formatId: string): Promise<void> {
    const res = await fetchWithAuth(`/slide-formats/${encodeURIComponent(formatId)}`, {
        method: "DELETE",
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "スライドフォーマットの削除に失敗しました");
}
